import type { ReactNode } from 'react';

export function SummaryStat({
  label,
  value,
}: {
  label: ReactNode;
  value: number;
}) {
  return (
    <div className="rounded-lg border p-3">
      <p className="text-xs text-muted-foreground">{label}</p>
      <p className="text-2xl font-semibold tabular-nums">{value}</p>
    </div>
  );
}
